import type { InternalNotesNotifySelection } from '../types'

export function isInternalNotesNotifySelectionValid(
  selection: InternalNotesNotifySelection,
): boolean {
  return Boolean(selection.email_sendto?.trim())
}

/** Maps dialog `email_sendto` to Angular `sendReviewUpdate` `message_send_to`. */
export function internalNotesMessageSendTo(emailSendTo: string | undefined): string | null {
  const map: Record<string, string> = {
    default_manager: 'default_mgr',
    success_manager: 'client_success',
    default_success: 'default_success',
    customer_service: 'customer_service',
  }
  if (!emailSendTo) return null
  return map[emailSendTo] ?? null
}

export function isInternalNotesOnlySave(emailSendTo: string | undefined): boolean {
  return emailSendTo === 'none' || emailSendTo === 'l1_review'
}

export type { InternalNotesNotifySelection } from '../types'

